import React from 'react';

import { useListAssociations } from 'legacy/groups/hooks';
import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';
import MemberOnlyRow from './MemberOnlyRow';

interface Props {
  isSelectionDisabled: boolean;
  selectedAssociations: string[];
  setSelectedAssociations: (data: string[]) => void;
}

const AssociationsOnlyAccess = ({
  isSelectionDisabled,
  selectedAssociations,
  setSelectedAssociations
}: Props) => {
  const { data: associations, isLoading } = useListAssociations();

  const handleSelect = (id: string) => {
    const newSelectedAssociations = [...selectedAssociations];
    const associationIndex = selectedAssociations.indexOf(id);

    if (associationIndex > -1) {
      newSelectedAssociations.splice(associationIndex, 1);
    } else {
      newSelectedAssociations.push(id);
    }

    setSelectedAssociations(newSelectedAssociations);
  };

  const clearSelectedAssociations = () => {
    setSelectedAssociations([]);
  };

  return (
    <>
      <div className="h-full pb-24 md:pb-16 overflow-auto max-h-[95vh] md:max-h-[600px]">
        <div className="p-4 pb-40">
          <div className="pt-2 pb-6 flex">
            <div className="flex-1 font-bold text-base">
              {`${selectedAssociations.length} ${
                selectedAssociations.length === 1
                  ? 'association'
                  : 'associations'
              } selected`}
            </div>
            {selectedAssociations.length > 0 && (
              <button
                type="button"
                aria-label="Clear selected associations"
                className="font-bold text-base text-primary-500"
                onClick={clearSelectedAssociations}
              >
                Clear
              </button>
            )}
          </div>
          {isLoading ? (
            <div className="flex flex-1 h-[400px] items-center justify-center">
              <Spinner type={SpinnerType.PRIMARY} />
            </div>
          ) : (
            <ul className="flex flex-col gap-2">
              {associations.map((association) => (
                <MemberOnlyRow
                  key={association.id}
                  name={association.name}
                  image={association.logoImage}
                  id={association.id}
                  isSelected={selectedAssociations.indexOf(association.id) > -1}
                  onSelect={handleSelect}
                  isDisabled={isSelectionDisabled}
                />
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default AssociationsOnlyAccess;
